import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Grid, IconButton, List, ListItem, Typography } from '@mui/material';
import { CustomModal } from '../../../../../components';
import Styles from '../styles.scss';
import { capitalize } from '../../../../../utils';
import { APPLICATION_STATUS } from '../../../../../constants/event-application-status';

function VendorApplicationDetailsModal({ isOpen, handleClose, details }) {
  const { notifications } = useSelector((store) => store.notifications);
  return (
    <CustomModal isOpen={isOpen} handleClose={handleClose}>
      <Grid
        container
        justifyContent="center"
        rowGap={1}
        sx={{ maxHeight: '34rem', overflowX: 'auto', padding: '10px' }}>
        <Grid item xs={12}>
          <IconButton onClick={handleClose}>
            <CancelOutlinedIcon sx={{ fill: '#0997ba' }} />
          </IconButton>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Application Details
          </Typography>
        </Grid>
        <Grid item xs={12} mt={2} maxHeight="50vh" overflow="auto">
          <Typography variant="h6">Space Dimension</Typography>
          <div className="detailsContainer">
            <Typography variant="body">{details?.space_dimension.size}</Typography>
            <Typography variant="body">{`$${details?.space_dimension.cost}`}</Typography>
          </div>
          <hr />
          {details?.vendor_event_features?.length > 0 && (
            <>
              <Typography variant="h6">Amenities</Typography>
              {details.vendor_event_features.map((f) => (
                <div key={f.feature.id} className="detailsContainer">
                  <Typography variant="body">{f.feature.name}</Typography>
                  <Typography variant="body">{`$${f.feature.price}`}</Typography>
                </div>
              ))}
              <hr />
            </>
          )}
          <div className="detailsContainer">
            <Typography variant="h6">Total</Typography>
            <Typography variant="body">
              {details?.application_status === APPLICATION_STATUS.INCOMPLETE
                ? capitalize(details?.application_status)
                : `$${details?.total_price}`}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </CustomModal>
  );
}

VendorApplicationDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  details: PropTypes.any.isRequired,
};

export default VendorApplicationDetailsModal;
